// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-_0e","newExpiryDate":"styles_newExpiryDate__2YE0W","footer":"styles_footer__2VYOT"};